'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debugDocumentModeWrapper = undefined;

var _getClientConfig = require('../../../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _debugUtil = require('../../../debug/debugUtil');

var _configConstants = require('../../../../../config/configConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Util
var CONSOLE_DOC_MODE_TIME_NAME = 'DOC_MODE';

/**
 * Wraps the document mode function with debugging logs if debugging is supported.
 */


// Constants
/* eslint-disable no-console */
// Config
var debugDocumentModeWrapper = exports.debugDocumentModeWrapper = function debugDocumentModeWrapper(documentModeFn) {
    var config = (0, _getClientConfig2.default)();

    // Don't debug if the console isn't good enough to, or the debug level is too low
    if (config.debugLevel < _configConstants.DEBUG_LEVEL.FINE && !(0, _debugUtil.isDebugEnabled)() || !console.group) return documentModeFn;

    console.groupCollapsed('%cDocument mode calculations', 'color: #f4511c');
    console.time(CONSOLE_DOC_MODE_TIME_NAME);
    console.info('%cCreating main clusters...', 'color: green');
    console.info('%c-----------------------------', 'color: green');

    return function (inputData) {
        var documentModeData = documentModeFn(inputData);

        if (documentModeData.earlyExit) {
            console.debug("Document mode exited early as there's so few data points, calculations are unnecessary");
            console.timeEnd(CONSOLE_DOC_MODE_TIME_NAME);
            console.groupEnd();
            return documentModeData;
        }

        console.debug('Distance Matrix:');
        console.table(documentModeData.dendrogramData.distanceMatrix.matrix);

        console.debug('Merges:');
        console.table(documentModeData.dendrogramData.usedDistances.map(function (distObj) {
            return {
                cluster1: distObj.clusters[0],
                cluster2: distObj.clusters[1],
                distance: distObj.dist
            };
        }));

        console.debug('Scree Plot:');
        var screePlotTableData = documentModeData.elbowPointData.points.map(function (pointData, index) {
            var tableData = {
                height: pointData.height,
                variance: pointData.variance
            };

            var errorData = documentModeData.elbowPointData.errorMargins[index - 1];
            if (errorData) {
                tableData.cumulativeError = errorData.cumulativeError;
                tableData.dTheta = errorData.dTheta;
            }

            return tableData;
        });
        console.table(screePlotTableData);
        console.debug('Variances:', documentModeData.elbowPointData.points.map(function (point) {
            return point.variance;
        }).join(', '));

        // Finding the elbow point
        console.debug('Elbow point:', documentModeData.elbowPointData.elbowPoint.x, ', Too linear:', documentModeData.elbowPointData.tooLinear);

        console.timeEnd(CONSOLE_DOC_MODE_TIME_NAME);
        console.groupEnd();

        return documentModeData;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/algorithm/documentModeDebugger.js
// module id = 2205
// module chunks = 0